import { useState, useEffect } from 'react';

// Shared Full/Compact view-mode preference for all calculators (crypto/forex/stocks/futures).
// Persisted to localStorage under one key so the choice is consistent across markets and reloads.
const STORAGE_KEY = 'quer_calc_view_mode';

const read = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'compact' ? 'compact' : 'full';
  } catch {
    return 'full';
  }
};

export function useViewMode() {
  const [viewMode, setViewMode] = useState(read);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, viewMode);
    } catch {
      /* ignore (private mode / disabled storage) */
    }
  }, [viewMode]);

  // keep multiple mounted calculators (and other tabs) in sync
  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === STORAGE_KEY && e.newValue) {
        setViewMode(e.newValue === 'compact' ? 'compact' : 'full');
      }
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  return [viewMode, setViewMode];
}

export default useViewMode;
